import React, { FC } from 'react'
import { WithQuestionnaires } from '../questionnaires/QuestionnaireProvider'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import I18n from 'i18n'
import Info from '../atomic/atoms/Info'
import classNames from 'classnames'

const questionnaireKey = 'kccq'
interface Questionnaires {
  areEnabled: boolean | null | undefined
  oneTimeResponseUrl: (key: string) => string
  myOpenResponses?: Array<{ questionnaire: { key: string }, uuid: string }>
  openQuestionnaireUrlForUuid: (uuid: string) => string
}

interface Props {
  hideKccq?: boolean
  withContainer?: boolean
  widerButton?: boolean
  questionnaires?: Questionnaires
}

const KccqButton: FC<Props> = ({
  hideKccq = false,
  withContainer = false,
  widerButton = false,
  questionnaires
}) => {
  const kccqEnabled = true

  if (hideKccq || questionnaires?.areEnabled !== true) {
    return null
  }

  const kccqResponse = questionnaires?.myOpenResponses?.find(
    response => response.questionnaire.key === questionnaireKey
  )

  if (kccqResponse == null) {
    return null
  }

  const link = questionnaires.openQuestionnaireUrlForUuid(kccqResponse.uuid)

  const buttonClasses = classNames(
    'waves-effect text-m waves-light button-primary text-primary-color background-background text-medium',
    withContainer && 'button welcome-container-button',
    !withContainer && 'data-button data-detail-page',
    widerButton && 'wider-data-button'
  )

  const Button: FC = () => (
    <a className={buttonClasses} href={link} aria-disabled={!kccqEnabled}>
      <FontAwesomeIcon icon='calendar-week' className='button-icon' />
      {I18n.t('components.welcome.fill_out_sportpro_wekelijks_logboek')}
      <Info
        text={I18n.t('components.welcome.fill_out_sportpro_wekelijks_logboek_tooltip')}
        tooltipId='fill-out-sportpro-logboek-tooltip'
      />
    </a>
  )

  return withContainer
    ? (
      <div className='col s6 m12'>
        <Button />
      </div>
      )
    : (
      <Button />
      )
}

export default WithQuestionnaires(KccqButton)
